import { render } from "./ErrorNotification.vue?vue&type=template&id=56b841c2&scoped=true"
import script from "./ErrorNotification.vue?vue&type=script&lang=js"
export * from "./ErrorNotification.vue?vue&type=script&lang=js"

import "./ErrorNotification.vue?vue&type=style&index=0&id=56b841c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b841c2"]])

export default __exports__